import AbsenceReasons from './AbsenceReasons';

export default AbsenceReasons;
